var see_more_dossier = function () {

    $('.see-more-button .btn').click(function(e){
        e.preventDefault();
        $(this).parent().hide();
        $(this).parent().siblings('.item-not-visible').show();
        // Case we use BS4 col
        $(this).parent().siblings('.d-none').toggleClass("d-none d-block");
        $(this).parent().siblings('.see-less-button').show();

    });

    $('.see-less-button .btn').click(function(e){
        e.preventDefault();
        $(this).parent().hide();
        $(this).parent().siblings('.item-not-visible').hide();
        $(this).parent().siblings('.d-block').toggleClass("d-block d-none");
        $(this).parent().siblings('.see-more-button').show();
    });

};
